const DEFAULT_BLOCK_TERM = 3000;

export default DEFAULT_BLOCK_TERM;
